export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home')
  },
  {
    path: '/mission',
    name: 'mission',
    component: () => import('@/views/mission-tips')
  },
  {
    path: '/midea-meeting',
    name: 'mideaMeeting',
    component: () => import('@/views/midea-meeting-tips')
  },
  {
    path: '/midea-meeting',
    name: 'mideaMeeting',
    component: () => import('@/views/midea-meeting-tips')
  }
]
